import { BANK_DETAILS } from '@/core/field-names';
import { validateBankDetailsCommonFields } from '@/core/validation/common/bank-details';
import { BankDetailFieldErrors } from '@/core/validation/field-errors';

export async function validateBankDetails(field) {
  switch (field.name) {
    case BANK_DETAILS.SORT_CODE: {
      if (!field.value) {
        return BankDetailFieldErrors.EmptySortCode;
      }
      const fieldValueWithoutSpace = field?.value?.replace(/\s/g, '');
      if (fieldValueWithoutSpace.length < 6) {
        return BankDetailFieldErrors.InvalidSortCode;
      }
      break;
    }
    case BANK_DETAILS.BANK_NAME: {
      if (!field.value) {
        return BankDetailFieldErrors.EmptyBankName;
      }
      break;
    }
    default: {
      return validateBankDetailsCommonFields(field);
    }
  }
  return '';
}
